import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/core/authentication/authentication.service';
import { XenditService } from 'app/core/services/xendit.service';
import { Account } from 'app/shared/models/account';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'modal-employee-xendit',
  templateUrl: './modal-employee-xendit.component.html',
  styleUrls: ['./modal-employee-xendit.component.scss']
})
export class ModalEmployeeXenditComponent implements OnInit {

  isLoading: boolean = false;
  eventData: any;
  id: any;
  employeePrice: any;
  loadingPrice: boolean = false;
  employeesToAdd: number = 1;

  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private xenditService: XenditService) {
  }

  ngOnInit(): void {
    this.getEmployeePrice();
  }

  getEmployeePrice() {
    this.loadingPrice = true;
    this.xenditService.getEmployeePrice().subscribe({
      next: res => {
        this.loadingPrice = false;
        this.employeePrice = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  // addEmployee(employeePrice: any) {
  //   this.isLoading = true;
  //   const storedAccount = localStorage.getItem('account');
  //   const account: Account = JSON.parse(storedAccount);

  //   const domain = window.location.origin;
  //   const success_url = `${domain}/#/employee-xendit`;
  //   const failUrl = `${domain}/#/employee-xendit`;
  //   const fee = 0;
  //   const price = employeePrice;
  //   const UUID = uuidv4();
  //   const employeeCount = this.employeesToAdd;

  //   this.xenditService.xenditPayEmployee(price, UUID, employeeCount, success_url, failUrl, account.email, account.name).subscribe({
  //     next: res => {
  //       this.isLoading = false;
  //       const invoiceUrl = res.checkoutUrl;
  //       window.location.href = invoiceUrl;
  //     },
  //     error: err => {
  //       console.log(err);
  //     }
  //   });
  // }

  addEmployee(employeePrice: any) {
    this.isLoading = true;
    this.xenditService.insertAdditionalEmployee(this.employeesToAdd).subscribe({
      next: res => {
        this.isLoading = false;
        this.activeModal.close();
        window.location.reload();
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  save() {
    this.isLoading = true;
  }
}
